import React, { Component } from 'react';
import axios from 'axios'
import { firebaseAuth, pythonApiIp, serverIp, toCurrency } from '../../../../config/constants'
import { Form, Segment, Button, Divider, Statistic } from 'semantic-ui-react'
import { SingleDatePicker } from 'react-dates';
import * as UiConsts from '../../../../config/UiConstants';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

class WithHoldingTax_add extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            openProjectsDropdownItemList: [],
            withHeldAmount: '',
            singleWithHoldingTax: '',
            withHoldingTax: ''
        }
    }


    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;
        let name = e.target.name;
        let value = e.target.value;
        this.setState(newState);
    }

    // "apiKey": "ad#4fsdUUddf",
    // "enteredBy": "ivanmworozi@gmail.com",
    //     "projectId": 4,
    //         "amountDep": 419700,
    //             "selectedDate": 1619154152000
    fetchSingleWithHoldingTax = () => {
        console.log("++++++++:fetchSingleWithHoldingTax");
        console.log("this.props.projectId:" + this.props.projectId)


        if (!this.props.projectId) {
            alert("No projectId ")
        } else {
            console.log("sending data..");

            this.setState({ loading: true });

            axios.post(serverIp + 'large_projects/fetchSingleWithHoldingTax', {
                apiKey: "enterWithholdingTax",
                projectId: this.props.projectId
            })
                .then((response) => {

                    //  console.log(response.data);

                    if (response.data.result && response.data.withHoldingTax) {
                        console.log("true.. adding project");

                        this.setState({
                            loading: false,
                            withHoldingTax: response.data.withHoldingTax
                        })

                        // alert(response.data.message);
                        //history.push("/dashboard/viewLargeProject/" + this.props.projectId);
                    } else {
                        console.log("FAILED");
                        this.setState({ loading: false });
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    sendWithHolingTax = () => {
        console.log("++++++++:sendWithHolingTax");
        console.log("this.props.projectId:" + this.props.projectId)
        console.log("this.props.user.email:" + this.props.user.email)
        console.log("dateNum:" + this.state.dateNum)

        if (!this.props.projectId) {
            alert("No projectId ")
        } else if (!this.props.user) {
            alert("No Entered By Provided")
        } else if (this.state.withHeldAmount == '') {
            alert("No withHeldAmount Selected")
        } else if (!this.state.dateNum) {
            alert("No date Selected")
        } else {
            console.log("sending data..");

            this.setState({ loading: true });

            axios.post(serverIp + 'large_projects/enterWithholdingTax', {
                apiKey: "enterWithholdingTax",
                projectId: this.props.projectId,
                enteredBy: this.props.user.email,
                amountDep: this.state.withHeldAmount,
                selectedDate: this.state.dateNum
            })
                .then((response) => {
                    this.setState({
                        loading: false
                    })
                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. adding project");

                        alert(response.data.message);
                        history.push("/dashboard/viewLargeProject/" + this.props.projectId);
                    } else {
                        console.log("FAILED");
                        this.setState({ loading: false });
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }


    dateSelectOnChange = (date) => {
        console.log("++++++++:dateSelectOnChange");
        console.log("date:" + date);
        console.log("date.getValue():" + date.valueOf());
        this.setState({
            date: date,
            dateNum: date.valueOf(),
            dateString: date.format('dddd MMMM Do')

        })
    }

    render() {

        const setVatButton = this.state.withHeldAmount != ''
            ? <Button color='violet'>SEND WITHOLDING</Button>
            : ''


        const viewWitholding = this.state.withHoldingTax != ''
            ? <div>
                {/* <Statistic.Group> */}
                <Statistic size='tiny'>
                    <Statistic.Value>{toCurrency(this.state.withHoldingTax.amountWitheld)}</Statistic.Value>
                    <Statistic.Label>Amount</Statistic.Label>
                </Statistic>
                {/* <Statistic size='tiny'>
                        <Statistic.Value>{this.state.withHoldingTax.dateWithHeld}</Statistic.Value>
                        <Statistic.Label>Date WithHeld</Statistic.Label>
                    </Statistic>
                </Statistic.Group> */}
            </div>
            : ''

        const enterVatAmount =
            <div>
                <Divider horizontal>{'ADD WITHOLDING TAX'}</Divider>

                <Form size='large' onSubmit={this.sendWithHolingTax}>

                    <h3>ENTER WITH HOLDING TAX</h3>
                    <SingleDatePicker
                        date={this.state.date} // momentPropTypes.momentObj or null
                        //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                        onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                        focused={this.state.focused} // PropTypes.bool
                        isOutsideRange={() => false}
                        onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                    />
                    <h2>{this.state.dateString}</h2>

                    <label>Enter WITHHELD AMOUNT</label>
                    <Form.Input
                        fluid
                        icon='money'
                        iconPosition='left'
                        placeholder='Withheld Amount'
                        type='number'
                        name="withHeldAmount"
                        value={this.state.withHeldAmount}
                        onChange={this.handleTextInputChange}
                    />

                    {setVatButton}

                </Form>
            </div>


        return (this.state.loading ? <UiConsts.LoadingComponent /> :
            <div>
                <Segment>
                    {enterVatAmount}
                    <br />
                    {viewWitholding}
                    <Button color='brown' onClick={this.fetchSingleWithHoldingTax}>VIEW THIS PROJECT WITHOLDING</Button>
                    <br />
                    <br />
                    <Button>
                        <a href={'https://datastudio.google.com/reporting/741dba6e-0bca-4988-9b5d-a00759f95f42'} target="_blank">VIEW ALL PROJECT WITHOLDING</a>
                    </Button>
                </Segment>


            </div>);
    }
}

export default WithHoldingTax_add;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/WithHoldingTax_add.js